export default __webpack_public_path__ + "static/ui-tasks-add-2eb9e7f815b884803021023755597abb.png";